import { configureStore } from '@reduxjs/toolkit';
import designDefinitionReducer from './designDefinitionSlice';
import modelDataReducer from './modelDataSlice';
import thunkMiddleware from 'redux-thunk';

export default configureStore({
	reducer: {
		designDefinition: designDefinitionReducer,
		modelData: modelDataReducer
	},
	middleware: getDefaultMiddleware => getDefaultMiddleware().concat(thunkMiddleware /* , logger*/),
	devTools: process.env.NODE_ENV !== 'production'
});
